(function () {
  'use strict';

  // Guard: el script se carga en la PDP (main-product) y globalmente desde
  // theme.liquid para el sheet de las cards; sin esto la IIFE corria dos veces
  // y el modal se abria duplicado.
  if (window.__thnProductZoomInit) return;
  window.__thnProductZoomInit = true;

  var HOVER_ZOOM = 2;
  var MODAL_ZOOM = 2.4;
  var HIRES_WIDTH = 1500;

  function isDesktop() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function hiResUrl(img, width) {
    var base = img.currentSrc || img.src || '';
    try {
      var u = new URL(base, window.location.href);
      u.searchParams.set('width', String(width));
      return u.href;
    } catch (e) {
      return base;
    }
  }

  function clamp01(n) {
    return Math.min(Math.max(n, 0), 1);
  }

  var hoverContainer = null;

  function containerOf(el) {
    if (!el || !el.closest) return null;
    var img = el.closest('.image-magnify-custom');
    return img ? img.parentElement : null;
  }

  function imgOf(container) {
    return container ? container.querySelector('.image-magnify-custom') : null;
  }

  function ensureHiRes(img) {
    if (!img || img.dataset.pzHires === '1') return;
    img.dataset.pzHires = '1';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = hiResUrl(img, HIRES_WIDTH);
  }

  function applyOrigin(container, clientX, clientY, scale) {
    var img = imgOf(container);
    if (!img) return;
    var r = container.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = clamp01((clientX - r.left) / r.width);
    var py = clamp01((clientY - r.top) / r.height);
    img.style.transformOrigin = px * 100 + '% ' + py * 100 + '%';
    img.style.transform = 'scale(' + scale + ')';
  }

  function resetImg(img) {
    if (!img) return;
    img.style.transform = '';
    img.style.transformOrigin = '';
    img.classList.remove('pz-zooming');
  }

  document.addEventListener('mouseover', function (e) {
    if (!isDesktop()) return;
    var container = containerOf(e.target);
    if (!container) return;
    hoverContainer = container;
    ensureHiRes(imgOf(container));
    applyOrigin(container, e.clientX, e.clientY, HOVER_ZOOM);
  });

  document.addEventListener('mousemove', function (e) {
    if (!hoverContainer || !isDesktop()) return;
    applyOrigin(hoverContainer, e.clientX, e.clientY, HOVER_ZOOM);
  });

  document.addEventListener('mouseout', function (e) {
    if (!hoverContainer) return;
    if (e.relatedTarget && hoverContainer.contains(e.relatedTarget)) return;
    resetImg(imgOf(hoverContainer));
    hoverContainer = null;
  });

  document.addEventListener(
    'click',
    function (e) {
      var img = e.target.closest && e.target.closest('.image-magnify-custom');
      if (!img) return;
      e.preventDefault();
      e.stopPropagation();
      openModal(img);
    },
    true
  );


  var modal, modalStage, modalImg, modalThumbs;
  var modalImages = [];
  var modalIndex = 0;

  /* Mobile: pinch, pan, swipe y doble toque sobre el stage del modal. */
  var TAP_SLOP = 10; // px que un toque puede moverse y seguir contando como toque
  var DOUBLE_TAP_MS = 320;
  var SWIPE_MIN = 50; // px de arrastre para pasar de foto con escala 1
  var EDGE_SWIPE_MIN = 70; // px que hay que tirar mas alla del borde con zoom

  var mScale = 1;
  var mTx = 0;
  var mTy = 0;
  var gestureMode = null; // 'pinch' | 'pan' | 'swipe' | null
  var gStartDist = 0;
  var gStartScale = 1;
  var gFocalX = 0;
  var gFocalY = 0;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchDx = 0;
  var touchDy = 0;
  var touchMoved = false;
  var panStartTx = 0;
  var panStartTy = 0;
  var edgePrev = false;
  var edgeNext = false;
  var lastTapTime = 0;
  var lastGestureEnd = 0;

  /* Desktop: dentro del modal el zoom sigue al mouse por defecto, para que el
     usuario lo note sin buscarlo; el clic lo alterna (apagado = foto completa
     aunque el mouse este encima). Cada apertura del modal vuelve a "activo". */
  var deskZoomOn = true;

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function touchDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function touchMid(t) {
    return {
      x: (t[0].clientX + t[1].clientX) / 2,
      y: (t[0].clientY + t[1].clientY) / 2,
    };
  }

  function stageCenter() {
    var r = modalStage.getBoundingClientRect();
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function applyModalTransform() {
    modalImg.style.transformOrigin = 'center center';
    modalImg.style.transform =
      'translate(' + mTx + 'px, ' + mTy + 'px) scale(' + mScale + ')';
  }

  // Cuanto puede desplazarse la foto ampliada sin dejar ver el fondo.
  function panBounds() {
    var r = modalStage.getBoundingClientRect();
    return {
      x: Math.max(0, (modalImg.clientWidth * mScale - r.width) / 2),
      y: Math.max(0, (modalImg.clientHeight * mScale - r.height) / 2),
    };
  }

  function clampTranslation() {
    var b = panBounds();
    mTx = Math.min(Math.max(mTx, -b.x), b.x);
    mTy = Math.min(Math.max(mTy, -b.y), b.y);
  }

  function resetModalZoom(animate) {
    mScale = 1;
    mTx = 0;
    mTy = 0;
    gestureMode = null;
    modalImg.style.transition = animate ? '' : 'none';
    modalImg.style.transform = '';
    modalImg.style.transformOrigin = 'center center';
    if (modalStage) modalStage.classList.remove('pz-zoomed');
    if (!animate) {
      void modalImg.offsetWidth;
      modalImg.style.transition = '';
    }
  }

  // Cambia de foto con una entrada corta desde el lado del gesto.
  function goTo(index, dir) {
    if (index < 0 || index >= modalImages.length || index === modalIndex) return false;
    showModalImage(index);
    if (!reducedMotion()) {
      modalImg.style.transition = 'none';
      modalImg.style.transform = 'translateX(' + dir * 60 + 'px)';
      void modalImg.offsetWidth;
      modalImg.style.transition = '';
      modalImg.style.transform = '';
    }
    return true;
  }

  function startSingle(touch) {
    touchStartX = touch.clientX;
    touchStartY = touch.clientY;
    touchDx = 0;
    touchDy = 0;
    panStartTx = mTx;
    panStartTy = mTy;
  }

  function onTouchStart(e) {
    if (isDesktop()) return;
    modalImg.style.transition = 'none';
    if (e.touches.length === 2) {
      gestureMode = 'pinch';
      touchMoved = true;
      gStartDist = touchDist(e.touches);
      gStartScale = mScale;
      var mid = touchMid(e.touches);
      var c = stageCenter();
      gFocalX = (mid.x - c.x - mTx) / mScale;
      gFocalY = (mid.y - c.y - mTy) / mScale;
      e.preventDefault();
    } else if (e.touches.length === 1) {
      touchMoved = false;
      startSingle(e.touches[0]);
      if (mScale > 1.01) {
        gestureMode = 'pan';
        // Con zoom solo se pasa de foto desde el borde: si al empezar este
        // arrastre la foto ya mostraba su borde, seguir tirando cambia de foto.
        // Un pan que llega al borde a mitad de gesto no cambia nada.
        var b = panBounds();
        edgePrev = mTx >= b.x - 1;
        edgeNext = mTx <= -b.x + 1;
      } else {
        gestureMode = 'swipe';
      }
    }
  }

  function onTouchMove(e) {
    if (isDesktop() || !gestureMode) return;
    e.preventDefault();

    if (gestureMode === 'pinch') {
      if (e.touches.length !== 2) return;
      var dist = touchDist(e.touches);
      var mid = touchMid(e.touches);
      var c = stageCenter();
      var s = Math.min(Math.max(gStartScale * (dist / gStartDist), 1), 4);
      mScale = s;
      mTx = mid.x - c.x - s * gFocalX;
      mTy = mid.y - c.y - s * gFocalY;
      applyModalTransform();
      return;
    }

    if (e.touches.length !== 1) return;
    touchDx = e.touches[0].clientX - touchStartX;
    touchDy = e.touches[0].clientY - touchStartY;
    if (!touchMoved) {
      if (Math.abs(touchDx) < TAP_SLOP && Math.abs(touchDy) < TAP_SLOP) return;
      touchMoved = true;
    }

    if (gestureMode === 'swipe') {
      // Escala 1: la foto sigue al dedo en horizontal; sin foto en esa
      // direccion va con resistencia, para que se note que no hay mas.
      var blocked =
        (touchDx > 0 && modalIndex === 0) || (touchDx < 0 && modalIndex >= modalImages.length - 1);
      mTx = blocked ? touchDx * 0.3 : touchDx;
      mTy = 0;
      applyModalTransform();
    } else if (gestureMode === 'pan') {
      var bounds = panBounds();
      var rawX = panStartTx + touchDx;
      mTy = Math.min(Math.max(panStartTy + touchDy, -bounds.y), bounds.y);
      if (rawX > bounds.x) {
        mTx = bounds.x + (edgePrev ? (rawX - bounds.x) * 0.35 : 0);
      } else if (rawX < -bounds.x) {
        mTx = -bounds.x + (edgeNext ? (rawX + bounds.x) * 0.35 : 0);
      } else {
        mTx = rawX;
      }
      applyModalTransform();
    }
  }

  function onTouchEnd(e) {
    if (isDesktop()) return;
    modalImg.style.transition = '';
    // Solo un gesto real anula el toque siguiente. Antes cualquier toque con la
    // foto ampliada contaba como pan, y el doble toque para alejar se ignoraba.
    if (touchMoved) lastGestureEnd = Date.now();

    if (e.touches.length === 1) {
      // Quedo un dedo tras un pinch: sigue como pan si hay zoom, sin cambiar de foto.
      startSingle(e.touches[0]);
      edgePrev = false;
      edgeNext = false;
      gestureMode = mScale > 1.01 ? 'pan' : null;
      return;
    }
    if (e.touches.length > 1) return;

    var mode = gestureMode;
    gestureMode = null;
    var horizontal = Math.abs(touchDx) > Math.abs(touchDy);

    if (mode === 'swipe' && touchMoved) {
      if (horizontal && Math.abs(touchDx) >= SWIPE_MIN) {
        var dir = touchDx < 0 ? 1 : -1;
        if (goTo(modalIndex + dir, dir)) return;
      }
      resetModalZoom(true);
      return;
    }

    if (mode === 'pan' && touchMoved && horizontal) {
      var b = panBounds();
      var rawX = panStartTx + touchDx;
      if (edgePrev && rawX - b.x >= EDGE_SWIPE_MIN && goTo(modalIndex - 1, -1)) return;
      if (edgeNext && -b.x - rawX >= EDGE_SWIPE_MIN && goTo(modalIndex + 1, 1)) return;
    }

    if (mScale <= 1.01) {
      resetModalZoom(true);
    } else {
      clampTranslation();
      applyModalTransform();
    }
  }

  function onStageTap(e) {
    if (gestureMode === 'pan' || gestureMode === 'pinch') return;
    if (Date.now() - lastGestureEnd < 350) return;

    if (e.target === modalStage) {
      closeModal();
      return;
    }

    if (isDesktop()) return;

    var now = Date.now();
    if (now - lastTapTime > DOUBLE_TAP_MS) {
      lastTapTime = now;
      return;
    }
    lastTapTime = 0;
    modalImg.style.transition = '';
    if (mScale > 1.01) {
      resetModalZoom(true);
    } else {
      var c = stageCenter();
      mScale = MODAL_ZOOM;
      mTx = (c.x - e.clientX) * (mScale - 1);
      mTy = (c.y - e.clientY) * (mScale - 1);
      clampTranslation();
      applyModalTransform();
    }
  }

  /* Desktop ----------------------------------------------------------------- */

  // Caja del <img> sin su transform (getBoundingClientRect ya vendria escalada):
  // el hover-zoom se decide sobre la foto a tamano normal, no sobre la ampliada.
  function imgBox() {
    var s = modalStage.getBoundingClientRect();
    return {
      left: s.left + modalImg.offsetLeft,
      top: s.top + modalImg.offsetTop,
      width: modalImg.offsetWidth,
      height: modalImg.offsetHeight,
    };
  }

  function deskZoomAt(clientX, clientY) {
    var r = imgBox();
    var inside =
      r.width > 0 &&
      clientX >= r.left &&
      clientX <= r.left + r.width &&
      clientY >= r.top &&
      clientY <= r.top + r.height;
    var zoom = deskZoomOn && inside;
    if (zoom) {
      var px = clamp01((clientX - r.left) / r.width);
      var py = clamp01((clientY - r.top) / r.height);
      modalImg.style.transformOrigin = px * 100 + '% ' + py * 100 + '%';
      modalImg.style.transform = 'scale(' + MODAL_ZOOM + ')';
    } else {
      // El origen se conserva: al alejar, la foto vuelve desde donde estaba.
      modalImg.style.transform = '';
    }
    modalStage.classList.toggle('pz-zoomed', zoom);
  }

  function setDeskZoom(on) {
    deskZoomOn = on;
    modal.classList.toggle('pz-zoom-off', !on);
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'pz-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Imagen ampliada');
    modal.innerHTML =
      '<button class="pz-modal__close" type="button" aria-label="Cerrar">&times;</button>' +
      '<div class="pz-modal__stage">' +
      '<img class="pz-modal__img" alt="">' +
      '<div class="pz-modal__spinner" aria-hidden="true"></div>' +
      '</div>' +
      '<div class="pz-modal__thumbs"></div>';
    document.body.appendChild(modal);

    modalStage = modal.querySelector('.pz-modal__stage');
    modalImg = modal.querySelector('.pz-modal__img');
    modalThumbs = modal.querySelector('.pz-modal__thumbs');

    modalImg.addEventListener('load', hideSpinner);
    modalImg.addEventListener('error', hideSpinner);

    modal.querySelector('.pz-modal__close').addEventListener('click', closeModal);

    modalImg.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      e.stopPropagation();
      setDeskZoom(!deskZoomOn);
      deskZoomAt(e.clientX, e.clientY);
    });
    modalStage.addEventListener('mousemove', function (e) {
      if (!isDesktop()) return;
      deskZoomAt(e.clientX, e.clientY);
    });
    modalStage.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      modalImg.style.transform = '';
      modalStage.classList.remove('pz-zoomed');
    });

    modalStage.addEventListener('touchstart', onTouchStart, { passive: false });
    modalStage.addEventListener('touchmove', onTouchMove, { passive: false });
    modalStage.addEventListener('touchend', onTouchEnd, { passive: false });
    modalStage.addEventListener('touchcancel', onTouchEnd, { passive: false });
    modalStage.addEventListener('click', onStageTap);

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('pz-open')) return;
      if (e.key === 'Escape') closeModal();
      else if (e.key === 'ArrowRight') goTo(modalIndex + 1, 1);
      else if (e.key === 'ArrowLeft') goTo(modalIndex - 1, -1);
    });
  }

  function collectImages(fromImg) {
    // [data-pz-gallery]: galeria propia (sheet de la card) fuera de la PDP.
    var gallery = fromImg.closest('media-gallery, [data-pz-gallery]') || document;
    var selector = '.product__media-item img.image-magnify-custom';
    if (gallery.hasAttribute && gallery.hasAttribute('data-pz-gallery')) selector = 'img.image-magnify-custom';
    var imgs = gallery.querySelectorAll(selector);
    var list = [];
    imgs.forEach(function (im) {
      // [data-pz-skip]: foto grande del sheet de las cards, duplicado de un thumb.
      if (im.hasAttribute('data-pz-skip')) return;
      list.push({
        full: hiResUrl(im, HIRES_WIDTH),
        thumb: im.currentSrc || im.src,
        alt: im.alt || '',
      });
    });
    return list;
  }

  function openModal(fromImg) {
    if (hoverContainer) {
      resetImg(imgOf(hoverContainer));
      hoverContainer = null;
    }
    resetImg(fromImg);

    if (!modal) buildModal();
    modalImages = collectImages(fromImg);
    if (!modalImages.length) return;

    var clicked = fromImg.currentSrc || fromImg.src;
    modalIndex = 0;
    if (fromImg.dataset.pzIndex !== undefined) {
      modalIndex = Math.min(Math.max(parseInt(fromImg.dataset.pzIndex, 10) || 0, 0), modalImages.length - 1);
    } else {
      for (var i = 0; i < modalImages.length; i++) {
        if (modalImages[i].thumb === clicked) {
          modalIndex = i;
          break;
        }
      }
    }

    setDeskZoom(true);
    renderThumbs();
    showModalImage(modalIndex);
    modal.classList.add('pz-open');
    document.body.classList.add('pz-modal-open');
  }

  function renderThumbs() {
    modalThumbs.innerHTML = '';
    modalThumbs.style.display = modalImages.length > 1 ? '' : 'none';
    modalImages.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-modal__thumb' + (i === modalIndex ? ' is-active' : '');
      b.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      var thumbImg = document.createElement('img');
      thumbImg.src = item.thumb;
      thumbImg.alt = '';
      b.appendChild(thumbImg);
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        showModalImage(i);
      });
      modalThumbs.appendChild(b);
    });
  }

  function showSpinner() {
    if (!modalStage) return;
    if (!modalStage.querySelector('.pz-modal__spinner')) {
      var sp = document.createElement('div');
      sp.className = 'pz-modal__spinner';
      sp.setAttribute('aria-hidden', 'true');
      modalStage.appendChild(sp);
    }
    modalStage.classList.add('pz-loading');
  }

  function hideSpinner() {
    if (!modalStage) return;
    modalStage.classList.remove('pz-loading');
  }

  // Con swipe la foto activa puede quedar fuera de la tira de thumbnails.
  function revealThumb(thumb) {
    if (!thumb || modalThumbs.scrollWidth <= modalThumbs.clientWidth) return;
    var left = thumb.offsetLeft - modalThumbs.offsetLeft - (modalThumbs.clientWidth - thumb.offsetWidth) / 2;
    modalThumbs.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function showModalImage(i) {
    modalIndex = i;
    resetModalZoom(false);
    showSpinner();
    modalImg.alt = modalImages[i].alt;
    modalImg.src = modalImages[i].full;
    if (modalImg.complete && modalImg.naturalWidth > 0) hideSpinner();
    Array.prototype.forEach.call(modalThumbs.children, function (c, idx) {
      c.classList.toggle('is-active', idx === i);
    });
    revealThumb(modalThumbs.children[i]);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('pz-open');
    document.body.classList.remove('pz-modal-open');
    resetModalZoom(false);
  }
})();
